import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cardBankData: {
      padding: '30px',
      minHeight: 410,
      height: 410,
    },
    bankData: {
      '& span': { wordBreak: 'break-word' },
    },
    cancelButton: {
      marginTop: 26,
    },
    cardTitle: {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 700,
      fontSize: '18px',
      color: theme.oysterTheme.pine,
    },
    cardInfo: {
      fontFamily: theme.typography.fontFamily,
      fontSize: '14px',
      color: theme.oysterTheme.charcoal,
      marginBottom: 10,
      textAlign: 'justify',
      display: 'block',
      lineHeight: 'inherit',
    },
    cardInfoBanner: {
      backgroundColor: 'rgba(24, 144, 255, .10)',
      textAlign: 'justify',
      display: 'block',
      lineHeight: 'inherit',
      padding: '12px 16px 12px 16px',
      borderRadius: 8,
      marginTop: 25,
      marginBottom: 25,
      fontSize: '16px',
      fontWeight: 500,
      color: '#011B34',
    },
    blueBold: {
      fontWeight: 700,
      color: '#1890FF',
    },
    bold: {
      fontWeight: 700,
    },
    card: {
      display: 'flex',
      background: theme.oysterTheme.cotton,
      borderRadius: '10px',
      flexDirection: 'column',
    },
  }),
);
export default useStyles;
